import request from '@/utils/request'
// import qs from 'qs'

// 合作伙伴列表
export const operaCompanyList = (getData) => {
  return request({
    url: '/web/cooperative-company/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}

// 详情
export const getId = (getData) => {
  return request({
    url: '/web/cooperative-company/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteOperaCompany = (getData) => {
  return request({
    url: '/web/cooperative-company/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateOperaCompany = (postData) => {
  return request({
    url: '/web/cooperative-company/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addOperaCompany = (postData) => {
  return request({
    url: '/web/cooperative-company/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
